@if(message() && control().invalid && control().dirty) {
<div class="text-red-600">
  {{ message() }}
</div>
}
